import {types} from './types';

const setGetCashbackListAction = (payload) => {
    return {
        type: types.SET_GET_CASHBACK_LIST,
        payload,
      }
}

export {
  setGetCashbackListAction
}